(() => {
  if (window.__ksMeasurementTracking) return;
  window.__ksMeasurementTracking = true;

  const path = window.location.pathname;
  const journeyFormId = '262500634912148';
  const journeyPath = '/pages/umrah-quotes';
  const confirmationPaths = new Set([
    '/pages/journey-planner-confirmation',
    '/pages/journey-planner-thank-you'
  ]);
  const measurementId = 'G-52G7M0XE7G';
  const metaPixelId = '3595710383984731';
  const pendingKey = 'ks_journey_pending_receipt';
  const verifiedKey = 'ks_confirmation_verified';
  const proofLifetimeMs = 30 * 60 * 1000;
  const formType = path === journeyPath
    ? 'traveler'
    : path === '/pages/agency-partnership-registration'
      ? 'agency'
      : null;
  let formStarted = false;
  let formCompleted = false;

  const safeSessionGet = (key) => {
    try { return sessionStorage.getItem(key) || ''; } catch (error) { return ''; }
  };

  const safeSessionSet = (key, value) => {
    try { sessionStorage.setItem(key, value); } catch (error) {}
  };

  const sendEvent = (name, params = {}) => {
    const payload = {
      ...params,
      page_path: path,
      device_group: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
    };

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(name, payload);
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
    }
  };

  const startForm = () => {
    if (!formType || formStarted) return;
    formStarted = true;
    safeSessionSet('ks_form_started_' + formType, '1');
    sendEvent('form_start', { form_type: formType });
    if (formType === 'agency') sendEvent('agency_registration_start');
  };

  const trustedJotformOrigin = (origin) => {
    try {
      const url = new URL(origin);
      return url.protocol === 'https:' &&
        (url.hostname === 'jotform.com' || url.hostname.endsWith('.jotform.com'));
    } catch (error) {
      return false;
    }
  };

  const recordPendingJourney = () => {
    let eventId = safeSessionGet('ks_lead_event_id');
    if (!eventId) {
      const frame = document.querySelector('iframe[src*="form.jotform.com/"], iframe[src*="form.jotformeu.com/"]');
      if (frame) {
        try { eventId = new URL(frame.src).searchParams.get('lead_event_id') || ''; } catch (error) {}
      }
    }
    if (eventId) safeSessionSet('ks_lead_event_id', eventId);
    if (!eventId) return;
    const landingPage = safeSessionGet('ks_tracker_landing_page') || window.location.href;
    const pending = {
      formId: journeyFormId,
      eventId,
      createdAt: Date.now(),
      qaTest: /(?:^|[?&])ks_qa=1(?:&|$)/.test(landingPage) ||
        new URLSearchParams(window.location.search).get('ks_qa') === '1',
      metaTestEventCode: (() => { try { return new URL(landingPage).searchParams.get('test_event_code') || ''; } catch (error) { return ''; } })()
    };
    safeSessionSet(pendingKey, JSON.stringify(pending));
  };

  if (path === journeyPath) {
    recordPendingJourney();
    let pendingAttempts = 0;
    const pendingTimer = setInterval(() => {
      pendingAttempts += 1;
      recordPendingJourney();
      if (safeSessionGet(pendingKey) || pendingAttempts >= 20) clearInterval(pendingTimer);
    }, 250);
  }

  window.addEventListener('blur', () => {
    setTimeout(() => {
      const active = document.activeElement;
      if (active && active.tagName === 'IFRAME' && /jotform/i.test(active.src || '')) startForm();
    }, 0);
  });

  window.addEventListener('message', (event) => {
    if (!trustedJotformOrigin(event.origin)) return;
    const raw = typeof event.data === 'string' ? event.data : JSON.stringify(event.data || {});
    if (/form-start|first-interaction|page-change|submission/i.test(raw)) startForm();
    if (!/submission-completed|form-submitted|thankyou/i.test(raw)) return;
    if (formCompleted) return;
    formCompleted = true;
    try { sessionStorage.removeItem('ks_form_started_' + formType); } catch (error) {}

    if (formType === 'traveler') {
      recordPendingJourney();
      return;
    }

    if (formType === 'agency') {
      sendEvent('generate_lead', { lead_type: formType });
      sendEvent('agency_registration_submit');
    }
  });

  const readValidJourneyProof = () => {
    if (!confirmationPaths.has(path)) return null;
    const search = new URLSearchParams(window.location.search);
    if (search.get('ks_lead') !== '1') return null;
    const submissionId = search.get('submission_id') || '';
    const receiptEventId = search.get('lead_event_id') || '';
    if (!/^\d{15,22}$/.test(submissionId)) return null;
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(receiptEventId)) return null;
    try {
      const pending = JSON.parse(safeSessionGet(pendingKey) || 'null');
      if (pending && pending.formId === journeyFormId && pending.eventId === receiptEventId &&
          Number.isFinite(pending.createdAt) && Date.now() - pending.createdAt <= proofLifetimeMs) {
        return { ...pending, submissionId };
      }

      if (safeSessionGet('ks_ga4_lead_sent_' + receiptEventId) === '1') {
        return { formId: journeyFormId, eventId: receiptEventId, submissionId, createdAt: Date.now(), qaTest: true, replayOnly: true };
      }

      const verified = JSON.parse(safeSessionGet(verifiedKey) || 'null');
      if (!verified || verified.formId !== journeyFormId || verified.eventId !== receiptEventId ||
          verified.submissionId !== submissionId) return null;
      if (!Number.isFinite(verified.createdAt) || Date.now() - verified.createdAt > proofLifetimeMs) return null;
      return verified;
    } catch (error) {
      return null;
    }
  };

  const dispatchVerifiedJourneyLead = () => {
    const proof = readValidJourneyProof();
    if (!proof) return;
    safeSessionSet(verifiedKey, JSON.stringify({ ...proof, createdAt: Date.now() }));

    const renderVerifiedConfirmation = () => {
      const neutral = Array.from(document.querySelectorAll('p')).find((node) =>
        node.textContent.trim() === 'This page does not confirm that a new request was submitted.'
      );
      if (!neutral) return;
      neutral.textContent = 'We received your Umrah journey request.';
      const detail = neutral.nextElementSibling;
      if (detail && detail.tagName === 'P') {
        detail.textContent = 'KaabaSharif will review your trip details and contact you with the next step.';
      }
    };
    renderVerifiedConfirmation();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', renderVerifiedConfirmation, { once: true });
    }

    if (proof.replayOnly) return;

    const params = {
      event_id: proof.eventId,
      lead_event_id: proof.eventId,
      submission_id: proof.submissionId,
      form_id: journeyFormId,
      lead_type: 'traveler',
      qa_test: Boolean(proof.qaTest),
        ...(proof.metaTestEventCode ? { test_event_code: proof.metaTestEventCode } : {}),
      page_path: path
    };

    const gaKey = 'ks_ga4_lead_sent_' + proof.eventId;
    if (safeSessionGet(gaKey) !== '1') {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('event', 'generate_lead', { ...params, send_to: measurementId });
      safeSessionSet(gaKey, '1');
    }

    const metaKey = 'ks_meta_lead_sent_' + proof.eventId;
    const sendMeta=()=>{if(safeSessionGet(metaKey)==='1')return;if(window.Shopify&&Shopify.customerPrivacy&&typeof Shopify.customerPrivacy.analyticsProcessingAllowed==='function'&&!Shopify.customerPrivacy.analyticsProcessingAllowed())return;if(typeof window.fbq!=='function'){!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=true;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=true;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');window.fbq('init',metaPixelId)}window.fbq('track','Lead',{form_id:journeyFormId,lead_type:'traveler',qa_test:Boolean(proof.qaTest)},{eventID:proof.eventId});safeSessionSet(metaKey,'1')};sendMeta();
  };

  dispatchVerifiedJourneyLead();

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (path.startsWith('/blogs/') && url.origin === window.location.origin && url.pathname === journeyPath) {
      sendEvent('blog_to_journey_planner_click', {
        article_path: path,
        link_text: (link.textContent || link.getAttribute('aria-label') || '').trim().replace(/\s+/g, ' ').slice(0, 100)
      });
    }
  }, { passive: true });

  document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('template-404') || document.querySelector('[data-template="404"]')) {
      sendEvent('page_not_found', { requested_path: path });
    }

    if (path === '/search') {
      const query = new URLSearchParams(window.location.search).get('q') || '';
      const cards = document.querySelectorAll('product-card, .resource-card, [data-product-card]');
      sendEvent('search_results_view', { search_term: query, result_count: cards.length });
      if (cards.length === 0) sendEvent('zero_results', { search_term: query });
    }
  });

  window.addEventListener('pagehide', () => {
    if (formType && formStarted && !formCompleted) sendEvent('form_abandon', { form_type: formType });
  });
})();
